import produce from 'immer';
import { UserGroupDto } from '../../models';
import { Licence } from '../licences/licence.types';
import {
	USER_LOAD_LICENCES,
	USER_SELECT_LICENCE,
	USER_LOAD_GROUPS
} from './user.actions';
import { IUserState, UserActions } from './user.types';

const userInitialState: IUserState = {};

export function userReducer(
	state: IUserState = userInitialState,
	action: UserActions
): IUserState {
	switch (action.type) {
		case USER_LOAD_LICENCES:
			return loadUserLicenceList(state, action.payload as string[]);
		case USER_SELECT_LICENCE:
			return loadSelectedLicence(state, action.payload as Licence);
		case USER_LOAD_GROUPS:
			return loadGroups(state, action.payload as UserGroupDto[]);
		default:
			return state;
	}
}

function loadGroups(
	currentState: IUserState,
	groups: UserGroupDto[]
): IUserState {
	return produce(currentState, (draftState: IUserState) => {
		draftState.groups = groups;
	});
}

function loadUserLicenceList(
	currentState: IUserState,
	licences: string[]
): IUserState {
	return produce(currentState, (draftState: IUserState) => {
		draftState.licences = licences;
	});
}

function loadSelectedLicence(
	currentState: IUserState,
	licence: Licence
): IUserState {
	return produce(currentState, (draftState: IUserState) => {
		draftState.selectedLicence = licence;
	});
}
